import './../styles/main.scss'; 
import { browserSupportsAllFeatures } from './test';
import { isDefined, throttle } from './partials/helpers';
import { triggerRevealScroll } from './partials/scroll-reveal';
import { preloadTransition } from './partials/preload-transition';
import { initParallax } from './partials/parallax';
import { initHeader } from './partials/header';
import { initDiscover } from './partials/discover';
import { initTemoignage } from './partials/temoignage';
import { initSliderAboutImage } from './partials/about';
import { initLightBox } from './partials/lighbox';
import { initReservation } from './partials/reservation';

if (module.hot) {
    module.hot.accept();
}

window.addEventListener('DOMContentLoaded', function() {
    
    if (!browserSupportsAllFeatures()) {
        // Require 'promise' for Parcel, then dynamic import polyfills.
        require('core-js/es/promise');
        import('./polyfill')
            .then(() =>
                console.log('Polyfills loaded... instantiate UI modules...')
            )
            .catch((e) => console.error(e));
    }

    if('IntersectionObserver' in window)
    {
        document.documentElement.classList.add('reveal-loaded')
        triggerRevealScroll();
    }

    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    setTimeout(function() {
        preloadTransition();
    }, 100);

    initHeader();
    initDiscover();
    initTemoignage();
    initSliderAboutImage();
    initLightBox();
    initReservation();

    // Uniquement en bureau
    if (window.matchMedia("(min-width: 999px)").matches) {
        initParallax();
        // Go to top button
        const goToTop = document.querySelector('.button-go-top');
        if(isDefined(goToTop)) {
            var myScrollFunc = function() {
                var y = window.scrollY;
                if (y >= 1200) {
                    goToTop.classList.add('is-visible');
                } else {
                    if(goToTop.classList.contains('is-visible')) {
                        goToTop.classList.remove('is-visible');
                    }
                }
            };
            window.addEventListener("scroll", throttle(myScrollFunc));
        }
    }

})